export default __webpack_public_path__ + "static/media/pjur.90b9f7ab.png";